import { lazy } from "react";

import { Navigate } from "react-router-dom";

import { RVRoutingPage } from "@regal-voice/ui";
import { USER_MANAGEMENT_PATH } from "Pages/settings/paths";

import { userManagementPathResources } from "./Pages/UserManagementPaths";

import type { RegalRouteObject } from "App/routes/types";

const UsersPage = lazy(() => import("./Pages/UsersPage/UsersPage"));
const TeamsPage = lazy(() => import("./Pages/TeamsPage/TeamsPage"));
const SkillsPage = lazy(() => import("./Pages/SkillsPage/SkillsPage"));
const CustomAttributesPage = lazy(() => import("./Pages/CustomAttributesPage/CustomAttributesPage"));
const CreateUserPage = lazy(() => import("./Pages/CreateUserPage/CreateUserPage"));
const CreateTeamPage = lazy(() => import("./Pages/CreateTeamPage/CreateTeamPage"));
const CreateSkillPage = lazy(() => import("./Pages/CreateSkillPage/CreateSkillPage"));
const CreateCustomAttributePage = lazy(() => import("./Pages/CreateCustomAttributePage/CreateCustomAttributePage"));

export const userManagementRoute: RegalRouteObject = {
    path: USER_MANAGEMENT_PATH,
    element: <RVRoutingPage />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <Navigate to={userManagementPathResources.users} replace />,
        },
        {
            path: userManagementPathResources.users,
            element: <UsersPage />,
        },
        {
            path: userManagementPathResources.teams,
            element: <TeamsPage />,
        },
        {
            path: userManagementPathResources.skills,
            element: <SkillsPage />,
        },
        {
            path: userManagementPathResources.customAttributes,
            element: <CustomAttributesPage />,
        },
        // These create/edit pages work in both modes
        {
            path: userManagementPathResources.newUser,
            element: <CreateUserPage />,
        },
        {
            path: userManagementPathResources.editUser,
            element: <CreateUserPage />,
        },
        {
            path: userManagementPathResources.newTeam,
            element: <CreateTeamPage />,
        },
        {
            path: userManagementPathResources.editTeam,
            element: <CreateTeamPage />,
        },
        {
            path: userManagementPathResources.newSkill,
            element: <CreateSkillPage />,
        },
        {
            path: userManagementPathResources.editSkill,
            element: <CreateSkillPage />,
        },
        {
            path: userManagementPathResources.newCustomAttribute,
            element: <CreateCustomAttributePage />,
        },
        {
            path: userManagementPathResources.editCustomAttribute,
            element: <CreateCustomAttributePage />,
        },
    ],
};
